export interface PurchaseOrderAllocation {
  id: string;
  salesOrderLineId: string;
  purchaseOrderAndLineNo: string;
  productKey: string;
  productDescription: string;
  productType: string;
  customerKey: string;
  customerName: string;
  orderNo: string;
  orderQuantity: number;
  deliveryDate: Date;
  allocationType: string;
  allocated: number;
  selected: boolean;
}
